export enum RFID {
  YES = "yes",
  NO = "no",
  EITHER = "either",
}

export enum QR_CODE {
  YES = "yes",
  NO = "no",
  EITHER = "either",
}

export enum WORK_TYPE {
  REGULAR = "regular",
  CORRECTIVE = "corrective",
  EITHER = "either",
}

export enum ENTITY_TYPE {
  ITEM = "item",
  AREA = "area",
  EITHER = "either",
}

export enum RAISED_THROUGH {
  YES = "yes",
  NO = "no",
  EITHER = "either",
}

export enum INCLUDE_SUPERSEDED {
  YES = "yes",
  NO = "no",
}

export enum INCLUDE_REJECTED {
  YES = "yes",
  NO = "no",
}

export enum PART_OF_WORK_ORDER {
  YES = "yes",
  NO = "no",
  EITHER = "either",
}
